SJ.SoundContainer = class {
  constructor(name, manager = false) {
    this.soundContainers = {};
    this.sounds = {};

    this.name = name;

    this.isManager = manager;
    this.hasParent = false;

    this.playLock = false;
  }

  createContainer(containerName) {
    this.soundContainers[containerName] = new SJ.SoundContainer(containerName);
    this.soundContainers[containerName].hasParent = true;
  }

  addContainer(container) {
    this.soundContainers[container.name] = container;
    this.soundContainers[container.name].hasParent = true;
  }

  createSound(
    audioName,
    fileName,
    volume = 0.5,
    loop = false,
    autoPlay = true,
    onEndCallback = null,
    soundPropagationDistance = 0,
    x = null,
    y = null,
    earsPositionX = null,
    earsPositionY = null,
    afterLoad = null,
    multiPlay = null,
    playIntervalTime = null
  ) {
    this.sounds[audioName] = new SJ.Sound(
      audioName,
      fileName,
      volume,
      loop,
      autoPlay,
      onEndCallback,
      soundPropagationDistance,
      x,
      y,
      earsPositionX,
      earsPositionY,
      afterLoad,
      multiPlay,
      playIntervalTime
    );

    if (this.isManager || this.hasParent) this.sounds[audioName].load();
  }

  addSound(sound) {
    this.sounds[sound.name] = sound;

    if (this.isManager || this.hasParent) this.sounds[sound.name].load();
  }

  pause(name = null, easy = false) {
    if (name) {
      if (easy) this.controlSpecificAudio(name, 'easyPause');
      else this.controlSpecificAudio(name, 'pause');
    } else {
      Object.keys(this.soundContainers).forEach((containerName) => {
        if (easy) this.soundContainers[containerName].easyPause();
        else this.soundContainers[containerName].pause();
      });

      Object.keys(this.sounds).forEach((soundName) => {
        if (easy) this.sounds[soundName].easyPause();
        else this.sounds[soundName].pause();
      });
    }
  }

  stop(name = null, easy = false) {
    if (name) {
      if (easy) this.controlSpecificAudio(name, 'easyStop');
      else this.controlSpecificAudio(name, 'stop');
    } else {
      Object.keys(this.soundContainers).forEach((containerName) => {
        if (easy) this.soundContainers[containerName].easyStop();
        else this.soundContainers[containerName].stop();
      });

      Object.keys(this.sounds).forEach((soundName) => {
        if (easy) this.sounds[soundName].easyStop();
        else this.sounds[soundName].stop();
      });
    }
  }

  play(name = null, easy = false) {
    if (this.playLock) return;

    if (name) {
      if (easy) this.controlSpecificAudio(name, 'easyPlay');
      else this.controlSpecificAudio(name, 'play');
    } else {
      Object.keys(this.soundContainers).forEach((containerName) => {
        if (easy) this.soundContainers[soundName].easyPlay();
        else this.soundContainers[soundName].play();
      });

      Object.keys(this.sounds).forEach((soundName) => {
        if (easy) this.sounds[soundName].easyPlay();
        else this.sounds[soundName].play();
      });
    }
  }

  controlSpecificAudio(audioName, functionName, args = []) {
    if (this.sounds[audioName]) this.sounds[audioName][functionName](...args);
    else console.error(`THERE IS NO ${audioName} AUDIO FILE`);
  }

  removeSpecificAudio(audioName) {
    this.sounds[audioName].stop();
    delete this.sounds[audioName];
  }

  lockPlaying() {
    // console.log('Locked', this);
    this.playLock = true;
    Object.keys(this.soundContainers).forEach((containerName) => {
      this.soundContainers[containerName].lockPlaying();
    });
  }

  unlockPlaying() {
    this.playLock = false;
    Object.keys(this.soundContainers).forEach((containerName) => {
      this.soundContainers[containerName].unlockPlaying();
    });
  }

  destruct() {
    Object.keys(this.soundContainers).forEach((containerName) => {
      this.soundContainers[containerName].destruct();
    });

    Object.keys(this.sounds).forEach((audioName) => {
      this.sounds[audioName].destruct();
    });

    this.sounds = [];
    this.soundContainers = [];
  }

  _update() {
    Object.keys(this.soundContainers).forEach((containerName) => {
      this.soundContainers[containerName]._update();
    });

    Object.keys(this.sounds).forEach((soundName) => {
      this.sounds[soundName]._update();
    });
  }
};

// SJ.SoundContainer =
//     class {
//         constructor(name) {
//             this.sounds = {};
//             this.name = name;
//         }

// clear() {
//     Object.keys(this.sounds).forEach(audioName => {
//         this.sounds[audioName].stop();
//     })

//     this.sounds = {};
// }

// createSound(audioName, fileName, volume = .5, loop = false, autoPlay = true, onEndCallback = null, soundPropagationDistance = 0, x = null, y = null, earsPositionX, earsPositionY, afterLoad = null) {

//     this.sounds[audioName] = new SJ.Sound(audioName, fileName, volume, loop, autoPlay, onEndCallback, soundPropagationDistance, x, y, earsPositionX, earsPositionY, afterLoad);

// }

// addSound(sound){
//     this.sounds[sound.name] = sound;
//     this.sounds[sound.name].load();
// }

// removeSpecificAudio(audioName) {
//     this.sounds[audioName].stop();
//     delete this.sounds[audioName];
// }

// controlSpecificAudio(audioName, functionName, args){
//     this.sounds[audioName][functionName]( ...args );
// }

// pause() {
//     Object.keys(this.sounds).forEach(audioName => {
//         this.sounds[audioName].pause();
//     })
// }

// play() {
//     Object.keys(this.sounds).forEach(audioName => {
//         this.sounds[audioName].play();
//     })
// }

// _update() {
//     Object.keys(this.sounds).forEach(audioName => {
//         this.sounds[audioName]._update();
//     })
// }

// }
